module.exports = __webpack_public_path__ + "img/main_boses1.116ae1f3.jpg";